import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "space-y-4 overflow-hidden p-6"
}
const _hoisted_2 = { class: "flex justify-end" }
const _hoisted_3 = { class: "text-2xl font-semibold text-gray-800" }
const _hoisted_4 = { class: "mt-1 text-sm text-gray-600" }
const _hoisted_5 = { class: "flex flex-col gap-4 lg:flex-row" }
const _hoisted_6 = { class: "h-[75vh] space-y-4 lg:w-1/2" }
const _hoisted_7 = { class: "flex h-[75vh] flex-col lg:w-1/2" }

import { ref, onMounted, computed } from 'vue';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';

import { useUiStore } from '@/stores';
import MeetingService from '@/services/api/MeetingService';
import { toastServiceError } from '@/services/core/notification';

import {
    calculateSpeechPercentage,
    formatMessagesWithElapsedTime,
    formatDateTime,
} from '@/utils/meeting';

import { SpeakerInsights, TranscriptSection } from '@/views/pages/meeting/components';
import { MeetingModel } from '@/types';
import { ChevronLeftIcon } from '@heroicons/vue/outline';

// Stores & Route

export default /*@__PURE__*/_defineComponent({
  __name: 'MeetingDetailPage',
  setup(__props) {

const uiStore = useUiStore();
const route = useRoute();
const { t } = useI18n();

// State
const meeting = ref<MeetingModel | null>(null);

// Computed
const isLoading = computed(() => uiStore.isLoading);
const formattedCreatedAt = computed(() => formatDateTime(meeting.value?.createdAt));

// Methods
const setLoading = (loading: boolean) => uiStore.setIsLoading(loading);

const getMeeting = async (id: number) => {
    try {
        await setLoading(true);

        const response = await MeetingService.get<MeetingModel>(id);
        meeting.value = response.data;

        if (meeting.value?.participants) {
            meeting.value.participants = calculateSpeechPercentage(meeting.value.participants);
        }

        if (meeting.value?.messages) {
            meeting.value.messages = formatMessagesWithElapsedTime(meeting.value.messages);
        }
    } catch (error) {
        toastServiceError(error);
    } finally {
        await setLoading(false);
    }
};

// Lifecycle
onMounted(() => {
    const meetingId = Number(route.params.id);
    getMeeting(meetingId);
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (meeting.value !== null && !isLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_router_link, {
              class: "text-primary hover:text-primary-dark ml-auto flex flex-row items-center",
              to: { name: 'MeetingList' }
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ChevronLeftIcon), { class: "h-5 w-6" }),
                _createTextVNode(" " + _toDisplayString(_unref(t)('core.actions.Back')), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("h1", _hoisted_3, _toDisplayString(meeting.value.title), 1),
          _createElementVNode("p", _hoisted_4, " Gravado por " + _toDisplayString(meeting.value.createdByUser?.name) + ", " + _toDisplayString(formattedCreatedAt.value) + ", " + _toDisplayString(Math.floor(meeting.value.speechDuration / 60)) + " min. ", 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_unref(SpeakerInsights), {
              participants: meeting.value.participants
            }, null, 8, ["participants"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_unref(TranscriptSection), {
              messages: meeting.value.messages,
              class: "overflow-y-auto rounded"
            }, null, 8, ["messages"])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})